module.exports = __webpack_public_path__ + "img/two_villas_holiday.be35414d.jpg";